import { GridActionsCellItem } from "@mui/x-data-grid";
import { ComponentProps } from "../types";
import { Icon } from "@mui/material";
import { useContext, useMemo } from "react";
import DashboardEnvContext from "../DashboardEnvContext";
import DashboardPageContext from "../DashboardPageContext";
import DataGridRowContext from "./DataGridRowContext";
import PagetActionsContext from "../PagetActionsContext";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dashboard = useContext(DashboardEnvContext);
	// TODO THIS IS WRONG AS THE MEMOS NEEDS TO LISTEN FOR ACTIONS ALSO
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const pageContext = useContext(DashboardPageContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const row = useContext(DataGridRowContext);
	const pageActions = useContext(PagetActionsContext);

	return (
		<>
			{dashboard && (
				<GridActionsCellItem
					icon={<Icon>{component.properties["icon"]}</Icon>}
					label={component.properties["label"]}
					title={component.properties["label"]}
					disabled={(component.properties["disabled"] && (evaluteScript(component.properties["disabled"]) as boolean)) || false}
					onClick={() => {
						pageActions.executePageAction(component.properties["submitAction"], {
							row: row,
							actionPayload: undefined,
						});
					}}
				/>
			)}
		</>
	);
}

export default Component;
